import * as yup from "yup";

const ReportByCranesSchema = yup.object().shape({
  start: yup.date().required("La fecha inicio es requerida"),
  end: yup.date().required("La fecha fin es requerida"),
  clerk: yup.string().required("El oficinista es requerido"),
  status: yup.string().required("El estatus orden es requerido"),
});

export default ReportByCranesSchema;